import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import {
    FacebookShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
    LineShareButton,
    LineIcon
} from "react-share";
import { Link } from "@components/Link"
import Image from "gatsby-image/withIEPolyfill"

import { useURL } from "@hooks/useURL"

import css from "@css/components/blocks/GlobalHeader.module.styl"
// import FujitsuSVG from "@images/GlobalHeader__logo__fujitsu.svg"
// import ArrowsSVG from "@images/GlobalHeader__logo__arrows.svg"

export default function GlobalFooter()
{
    return(
        <React.Fragment>
        <noscript dangerouslySetInnerHTML={{__html:`
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NC3KPSF"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `}}/>
        <div style={{background: `#fff`}} dangerouslySetInnerHTML={{__html: `
        <script src="/product/phone/common/gnavi/js/arrows.js" charset="UTF-8"></script>
        <noscript>
            <header id="header2017">
                <div class="header-container">
                    <div class="header-inr header-inr-lv1">
                        <h1 class="header-logo"><a href="http://jp.fujitsu.com/"><img src="/product/phone/common/gnavi/img/id.png" alt="FUJITSU"></a></h1>
                        <p class="header-title"><a href="/product/phone/arrows/"><img src="/product/phone/common/gnavi/img/arrows.png" alt="arrows"></a></p>
                        <div class="header-ui">
                            <a href="/product/phone/biz/" class="header-btn">法人のお客様はこちら</a>
                        </div>
                    </div>
                </div>
            </header>
        </noscript>
        `
        }}/>
        </React.Fragment>
    )
}
